export default {

    emits: ['update:valid'],

    props: {
        valid: {
            type: Boolean,
            default: true // We set it to true initially to trigger initial watchers when components are initially set to invalid, e.g., to receive initial error messages for AjaxForm
        }
    },

    data() {
        return {
            isValid: this.valid
        }
    },

    watch: {
        valid(valid) {
            this.isValid = valid;
        },

        isValid(isValid) {
            this.$emit('update:valid', isValid)
        }
    }
}
